(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .component("seminarForm", {
        templateUrl: "app/seminar/seminarForm.component.html",
        controller: ["facilityResource", "timeZoneService", "tenantResource", "learningItemSeminarsResource", "calendarSettingsService", "messageService", "frameworkService", "authService", "REG_EXP", "$localStorage", "$state", "_", "$scope", "$http", "$timeout", "$uibModal", "DTOptionsBuilder", "$translate", "$compile", "$filter", "$q", "$sessionStorage", "$window", SeminarFormCtrl],
        controllerAs: "vm"
    });
    function SeminarFormCtrl(facilityResource, timeZoneService, tenantResource, learningItemSeminarsResource, calendarSettingsService, messageService, frameworkService, authService, REG_EXP, $localStorage, $state, _, $scope, $http, $timeout, $uibModal, DTOptionsBuilder, $translate, $compile, $filter, $q, $sessionStorage, $window) {
        var vm = this;
        vm.loading = true;
        vm.showRegistrantErrors = false;
        vm.frameworkData = frameworkService.data;
        vm.enabledLocalizations = frameworkService.data.tenant.enabledLocalizations;
        vm.organizationEnabled = frameworkService.data.tenantFeatures.organization;
        var currentLocalizationId = parseInt($localStorage.currentLocalizationId);
        vm.localization = _.find(vm.enabledLocalizations, { id: currentLocalizationId });
        var hasSuperPower = _.includes(authService.authentication.roles, "Super Admin")
            || _.includes(authService.authentication.roles, "Site Admin")
            || _.includes(authService.authentication.roles, "Learning Item Admin");
        vm.isEditable = hasSuperPower;
        vm.isFacilitator = _.includes(authService.authentication.roles, "Facilitator");
        vm.isGroupAdmin = _.includes(authService.authentication.roles, "Group Admin");
        vm.checkSpecialCharacter = function (val) {
            if (val)
                return val.match(REG_EXP.commonSpecialCharacterExclude) !== null;
            return true;
        };
        //Date picker Config
        vm.datePickerList = {
            seminarDate: false,
            enrollmentCutOffDate: false,
            selfWithdrawalCutOffDate: false
        };
        vm.format = "mediumDate";
        calendarSettingsService.calendarSetup($scope);
        vm.openToggle = calendarSettingsService.openToggle;
        vm.cancel = function () {
            $state.go("main.learningItems.manageSeminars");
        };
        timeZoneService.getListOfTimeZones(function (data) {
            vm.timeZones = data;
            load();
        });
        ////////////////////////////////////////////////////////////
        function load() {
            //Initial Page load is it add or Edit?
            if ($state.current.name === "main.learningItems.addSeminar") {
                vm.state = "Add";
                vm.pageTitle = "menu.seminar.addSeminar";
                vm.model = {
                    seminarId: null,
                    localizationId: currentLocalizationId,
                    timeZone: null,
                    facilityInfo: { facilityAddress: { id: null } },
                    seminarDates: [],
                    minEnrollment: 10,
                    maxEnrollment: 10,
                    allowOverbooking: false
                };
                learningItemSeminarsResource.getCreateSeminarViewModel(function (data) {
                    vm.seminars = data.seminars;
                    vm.seminar = _.find(vm.seminars, { "code": $state.params.code });
                    vm.facilitators = data.facilitators;
                    //vm.timeZones = data.timeZones;
                    tenantResource.getTimeZone(function (tenantTimeZoneData) {
                        //Set Time Zone To Tenants
                        if (tenantTimeZoneData.timeZone)
                            vm.selectedTimeZone = tenantTimeZoneData.timeZone;
                        else
                            vm.selectedTimeZone = timeZoneService.detectTimeZone(vm.timeZones);
                        vm.model.timeZone = vm.selectedTimeZone.Id;
                    });
                    vm.loading = false;
                });
            }
            else {
                vm.state = "Edit";
                learningItemSeminarsResource.get({ id: $state.params.id }, function (data) {
                    vm.model = data;
                    vm.showAddCompleted = authService.isSuperAdmin() && new Date(data.endDate + "Z") < new Date();
                    vm.localization = _.find(vm.enabledLocalizations, { id: data.localizationId });
                    //Load Seminar Data
                    vm.seminars = data.seminars;
                    vm.seminar = _.find(vm.seminars, { "code": vm.model.learningItemCode });
                    //Load Facilitator Data
                    vm.facilitators = data.facilitators;
                    vm.facilitator = _.find(vm.facilitators, { "id": vm.model.facilitatorId });
                    //Load Start Date
                    var startDate = data.startDate + "Z";
                    var startTime = data.startDate + "Z";
                    vm.model.startDate = moment(startDate).toDate();
                    vm.startDateTime = moment(startTime).toDate();
                    var endDate = data.endDate + "Z";
                    vm.model.endDate = moment(endDate).toDate();
                    vm.pageTitle = "seminars.edit.title";
                    //Load Self Enroll and withdrawal Dates
                    if (data.selfEnrollmentCutOffDate) {
                        vm.model.selfEnrollmentCutOff = new Date(data.selfEnrollmentCutOffDate + "Z");
                        vm.selfEnrollCutOffTime = new Date(data.selfEnrollmentCutOffDate + "Z");
                    }
                    if (data.selfWithdrawalCutOffDate) {
                        vm.model.selfWithdrawalCutOff = new Date(data.selfWithdrawalCutOffDate + "Z");
                        vm.selfWithdrawalCutOffTime = new Date(data.selfWithdrawalCutOffDate + "Z");
                    }
                    //Load Additional Dates
                    var seminarDates = [];
                    for (var item in data.seminarDates) {
                        if (data.seminarDates[item].hasOwnProperty("id") && data.seminarDates[item].hasOwnProperty("date") && data.seminarDates[item].hasOwnProperty("start") && data.seminarDates[item].hasOwnProperty("end")) {
                            var seminarDate = {
                                id: data.seminarDates[item].id, date: new Date(data.seminarDates[item].date + "Z"), start: new Date(data.seminarDates[item].start + "Z"), end: new Date(data.seminarDates[item].end + "Z")
                            };
                            seminarDates.push(seminarDate);
                        }
                    }
                    vm.model.seminarDates = seminarDates;
                    //Load Time Zone Data
                    //vm.timeZones = data.timeZones;
                    vm.selectedTimeZone = _.find(vm.timeZones, {
                        "Id": data.timeZone
                    });
                    vm.loading = false;
                });
            }
        }
        var maxAdditionalDates = 20;
        vm.startDateChanged = function (date) {
            vm.additionalDateOptions = {};
            vm.additionalDateOptions.minDate = date ? date : new Date();
        };
        vm.enrollCutOffDateOptions = {
            minDate: new Date()
        };
        vm.withdrawalCutOffDateOptions = {
            minDate: new Date()
        };
        vm.dateChanged = function (date, start, end, viewValue) {
            if (date) {
                if (vm.state === "Edit") {
                    if (viewValue) {
                        var view = new Date(viewValue);
                        date.setUTCFullYear(view.getUTCFullYear());
                        date.setUTCMonth(view.getUTCMonth());
                        date.setUTCDate(view.getUTCDate());
                    }
                }
                if (start) {
                    var startHour = start.getUTCHours();
                    var startMinutes = start.getUTCMinutes();
                    start.setUTCFullYear(date.getUTCFullYear());
                    start.setUTCMonth(date.getUTCMonth());
                    start.setUTCDate(date.getUTCDate());
                    date.setUTCHours(startHour);
                    date.setUTCMinutes(startMinutes);
                    date.setUTCSeconds(0);
                }
                if (end) {
                    end.setUTCFullYear(date.getUTCFullYear());
                    end.setUTCMonth(date.getUTCMonth());
                    end.setUTCDate(date.getUTCDate());
                }
            }
        };
        vm.timeChanged = function (date, startTime) {
            //If seminar date is not null change the time to the start time
            //and set start time date to seminar Date
            if (startTime) {
                var startHour = startTime.getHours();
                var startMinutes = startTime.getMinutes();
                if (date) {
                    date.setUTCHours(startHour);
                    date.setUTCMinutes(startMinutes);
                    startTime.setUTCFullYear(date.getUTCFullYear());
                    startTime.setUTCMonth(date.getUTCMonth());
                    startTime.setUTCDate(date.getUTCDate());
                    startTime.setUTCHours(startHour);
                    startTime.setUTCMinutes(startMinutes);
                    startTime.setUTCSeconds(0);
                }
                else {
                    startTime.setUTCHours(startHour);
                    startTime.setUTCMinutes(startMinutes);
                    startTime.setUTCSeconds(0);
                }
            }
        };
        vm.seminarEndTimeChanged = function (date, endTime) {
            //Set end time date to  seminar date if seminar date not null
            if (endTime) {
                var endHour = endTime.getHours();
                var endMinutes = endTime.getMinutes();
                if (date) {
                    endTime.setUTCFullYear(date.getUTCFullYear());
                    endTime.setUTCMonth(date.getUTCMonth());
                    endTime.setUTCDate(date.getUTCDate());
                    endTime.setUTCHours(endHour);
                    endTime.setUTCMinutes(endMinutes);
                    endTime.setUTCSeconds(0);
                }
                else {
                    endTime.setUTCHours(endHour);
                    endTime.setUTCMinutes(endMinutes);
                    endTime.setUTCSeconds(0);
                }
            }
        };
        vm.removeDate = function (date) {
            var modal = $uibModal.open({
                templateUrl: "removeSeminarDates.html",
                backdrop: false,
                animation: false,
                windowClass: "confirmation-modal"
            });
            modal.result.then(function () {
                var removeDate = _.find(vm.model.seminarDates, {
                    'id': date
                });
                vm.model.seminarDates = angular.copy(_.without(vm.model.seminarDates, removeDate));
            }).catch(angular.noop);
        };
        vm.addAnotherSeminarDate = function () {
            var id;
            if (vm.model.seminarDates.length < maxAdditionalDates) {
                if (vm.model.seminarDates.length === 0) {
                    id = 1;
                }
                else {
                    id = _.max(_.pluck(vm.model.seminarDates, "id")) + 1;
                }
                vm.datePickerList[id] = false;
                var newDate = {
                    "id": id, "date": "", "start": "", "end": ""
                };
                vm.model.seminarDates.push(newDate);
                vm.showErrors = false;
            }
            else {
                messageService.warning("seminars.seminarDates.info.maxDatesReached");
            }
        };
        function validate() {
            var isValid = true;
            //Validate Start and End Date
            if (vm.model.startDate > vm.model.endDate)
                isValid = false;
            if (!vm.model.startDate || !vm.model.endDate || !vm.startDateTime)
                isValid = false;
            //Validate Additional Dates
            for (var item in vm.model.seminarDates) {
                if (vm.model.seminarDates[item].hasOwnProperty("start") && vm.model.seminarDates[item].hasOwnProperty("end")) {
                    if (vm.model.seminarDates[item].start > vm.model.seminarDates[item].end)
                        isValid = false;
                    if (vm.model.seminarDates[item].end < vm.model.seminarDates[item].start)
                        isValid = false;
                }
            }
            //Validate Self Enrollment Input
            if (vm.model.isSelfEnrollmentEnabled) {
                if (!vm.selfEnrollCutOffTime || !vm.model.selfEnrollmentCutOff)
                    isValid = false;
            }
            //Validate Self Withdrawal Input
            if (vm.model.isSelfWithdrawalEnabled) {
                if (!vm.selfWithdrawalCutOffTime || !vm.model.selfWithdrawalCutOff)
                    isValid = false;
            }
            if (parseInt(vm.model.minEnrollment) > parseInt(vm.model.maxEnrollment))
                isValid = false;
            return isValid;
        }
        vm.checkMaxMinEnrollment = function (min, max) {
            if (parseInt(min) > parseInt(max)) {
                return true;
            }
            else {
                return false;
            }
        };
        vm.save = function () {
            var isValid = validate();
            if (vm.form.$valid && isValid) {
                if (vm.saving)
                    return;
                vm.saving = true;
                vm.model.learningItemCode = vm.seminar.code;
                if (vm.state === "Add") {
                    learningItemSeminarsResource.save({}, vm.model, function (data) {
                        messageService.success("seminars.success.seminarSaved");
                        $state.go("main.learningItems.editSeminar", { id: data.id });
                        vm.saving = false;
                    }, function (error) {
                        vm.saving = false;
                        messageService.error(error);
                    });
                }
                else {
                    learningItemSeminarsResource.update({ id: $state.params.id }, vm.model, function () {
                        messageService.success("seminars.success.seminarSaved");
                        vm.saving = false;
                    }, function (error) {
                        vm.saving = false;
                        messageService.error(error);
                    });
                }
            }
            vm.showErrors = true;
        };
        vm.saveAndCreateAnother = function () {
            var isValid = validate();
            if (vm.form.$valid && isValid) {
                if (vm.saving)
                    return;
                vm.saving = true;
                vm.model.learningItemCode = vm.seminar.code;
                if (vm.state === "Add") {
                    learningItemSeminarsResource.save({}, vm.model, function (data) {
                        messageService.success("seminars.success.seminarSaved");
                        clearForm();
                        vm.showErrors = false;
                        $state.go("main.learningItems.addSeminar", { code: data.learningItemCode });
                        vm.saving = false;
                    }, function (error) {
                        vm.saving = false;
                        messageService.error(error);
                    });
                }
                else {
                    learningItemSeminarsResource.update({ id: $state.params.id }, vm.model, function () {
                        messageService.success("seminars.success.seminarSaved");
                        $state.go("main.learningItems.manageSeminars");
                        vm.saving = false;
                    }, function (error) {
                        vm.saving = false;
                        messageService.error(error);
                    });
                }
            }
            vm.showErrors = true;
        };
        function clearForm() {
            vm.facilitator = null;
            vm.startDateTime = null;
            vm.selfEnrollmentCutOff = null;
            vm.selfEnrollCutOffTime = null;
            vm.selfWithdrawalCutOff = null;
            vm.selfWithdrawalCutOffTime = null;
            vm.model.seminarId = null;
            vm.model.startDate = null;
            vm.model.endDate = null;
            vm.model.seminarNotes = null;
            vm.model.isSelfEnrollmentEnabled = false;
            vm.model.isSelfWithdrawalEnabled = false;
            vm.model.facilityInfo = {
                id: null,
                facilityAddress: {
                    id: null
                }
            };
            vm.model.seminarDates = [];
            vm.model.minEnrollment = 10;
            vm.model.maxEnrollment = 10;
        }
        vm.getFacility = function (val) {
            if (val !== "" && val !== undefined && val !== null) {
                if (val.match(REG_EXP.harmfulCheck) === null) {
                    return $http.get("api/facilities/filter/" + val, { params: {} })
                        .then(function (response) {
                        if (response) {
                            return response.data.map(function (item) {
                                return item;
                            });
                        }
                        else
                            return "";
                    }).catch(angular.noop);
                }
            }
            return "";
        };
        vm.getCityFacility = function (val) {
            if (val !== "" && val !== undefined && val !== null) {
                if (val.match(REG_EXP.harmfulCheck) === null) {
                    return $http.get("api/facilities/filterCity/" + val, {})
                        .then(function (response) {
                        return response.data.map(function (item) {
                            return item;
                        });
                    }).catch(angular.noop);
                }
            }
            return "";
        };
        vm.onFacilitySelect = function (item) {
            vm.model.facilityInfo = item;
        };
        vm.isNewFacility = function (val) {
            if (val !== "" && val !== undefined && val !== null) {
                if (val.match(REG_EXP.harmfulCheck) === null) {
                    facilityResource.getFacilityByName({ facilityName: val }, function (data) {
                        if (data.id === 0) {
                            vm.model.facilityInfo.id = null;
                            vm.model.facilityInfo.facilityAddress.id = null;
                        }
                    });
                }
            }
            else {
                vm.model.facilityInfo.id = null;
                vm.model.facilityInfo.facilityAddress.id = null;
            }
        };
        vm.seminarChanged = function () {
            if (vm.seminar)
                vm.model.seminarId = vm.seminar.id;
            else
                vm.model.seminarId = null;
        };
        vm.facilitatorChanged = function () {
            if (vm.facilitator)
                vm.model.facilitatorId = vm.facilitator.id;
            else
                vm.model.facilitatorId = null;
        };
        vm.timeZoneChanged = function () {
            if (vm.selectedTimeZone)
                vm.model.timeZone = vm.selectedTimeZone.Id;
            else
                vm.model.timeZone = null;
        };
        vm.languageChanged = function () {
            if (vm.localization)
                vm.model.localizationId = vm.localization.id;
            else
                vm.model.localizationId = $localStorage.currentLocalizationId;
        };
        //START REGISTERED LEARNERS SECTION
        var selectAllHtml = "<pretty-checkbox ng-click='vm.updateAllCheckBoxes()' label='false' ng-model='vm.selectAll' class='pretty-checkbox-table'/><div class='clearfix'></div>";
        vm.learnerListModel = [];
        vm.lang = $translate.proposedLanguage() || $translate.use();
        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            vm.allItemsMap = {};
            return $q(function (resolve) {
                var promise = learningItemSeminarsResource.getRegisteredLearners({ id: $state.params.id }).$promise;
                promise.then(function (data) {
                    vm.learnerListModel = _.map(data, function (item) {
                        return item;
                    });
                    resolve(data);
                });
            });
        })
            .withOption("createdRow", function (row, data) {
            // Recompiling so we can bind Angular directive to the DT
            $compile(angular.element(row).contents())($scope);
            row.id = data.personSeq;
        })
            .withOption("headerCallback", function (header) {
            if (!vm.headerCompiled) {
                // Use this headerCompiled field to only compile header once
                vm.headerCompiled = true;
                $compile(angular.element(header).contents())($scope);
            }
        })
            .withLanguageSource("/app/i18n/datatables/" + vm.lang + ".json")
            .withOption("processing", true)
            .withOption("responsive", { details: { type: "column" } })
            .withOption("stateSave", true)
            .withOption("stateDuration", -1)
            .withOption("rowCallback", rowCallback)
            //.withOption("paging", false)
            .withOption("lengthChange", false)
            .withOption("info", false)
            .withOption("order", [2, "asc"])
            .withOption("fnDrawCallback", function () {
            $timeout(function () {
                vm.resetTheSelectedRows();
            });
        })
            .withBootstrap();
        vm.dtColumns = [
            {
                "data": null,
                "defaultContent": "",
                "class": "control",
                "sortable": false,
                "targets": 0
            },
            {
                "render": function (_data, _type, full) {
                    vm.allItemsMap[full.personSeq] = {
                        registrant: full, checked: false
                    };
                    return "<pretty-checkbox name='checkBox' label='false' id='" + full.personSeq + "' ng-model='vm.allItemsMap[" + full.personSeq + "].checked' ng-click='vm.itemChecked()' class='pretty-checkbox-table clearfix'></pretty-checkbox>";
                },
                "sortable": false,
                "title": selectAllHtml
            },
            {
                "data": "personSeq",
                "title": $translate.instant("common.regNo")
            },
            {
                "data": "name",
                "title": $translate.instant("common.lists.learner")
            },
            {
                "data": "email",
                "sortable": false,
                "title": $translate.instant("common.lists.email")
            },
            {
                "data": "phone",
                "sortable": false,
                "title": $translate.instant("common.lists.phone")
            },
            {
                "data": "attended",
                "sortable": false,
                "class": "text-center",
                "title": $translate.instant("common.lists.attended"),
                "render": function (data) {
                    return $filter("checkboxIcon")(data);
                }
            },
        ];
        if (vm.organizationEnabled) {
            vm.dtColumns.splice(-1, 0, {
                "data": "organization",
                "title": $translate.instant("common.lists.organization"),
                "sortable": false,
            });
        }
        function rowCallback(nRow, data) {
            // Unbind first in order to avoid any duplicate handler (see https://github.com/l-lin/angular-datatables/issues/87)
            $("td:not(.control)", nRow).unbind("click");
            $("td:not(.control)", nRow).bind("click", function (e) {
                var element = $(e.target);
                if (element.attr("name") === "checkBoxTd" || element.parent().attr("name") === "checkBox")
                    return;
                element.bind("click", vm.rowClicked(data));
            });
            return nRow;
        }
        vm.rowClicked = function (learner) {
            vm.allItemsMap[learner.personSeq].checked = !vm.allItemsMap[learner.personSeq].checked;
            $scope.$apply();
        };
        if ($sessionStorage.registrantFilter) {
            vm.dtSearch = $sessionStorage.registrantFilter.search;
        }
        else {
            vm.dtSearch = "";
        }
        vm.search = function (value) {
            $sessionStorage.registrantFilter = {
                search: vm.dtSearch
            };
            vm.dtInstance.DataTable.search(value).draw();
        };
        vm.dtInstanceCallback = function (instance) {
            vm.dtInstance = instance;
        };
        vm.resetTheSelectedRows = function () {
            for (var key in vm.allItemsMap) {
                if (vm.allItemsMap.hasOwnProperty(key)) {
                    vm.allItemsMap[key].checked = false;
                }
            }
            vm.selectAll = false; //clear the select all check box
        };
        vm.updateAllCheckBoxes = function () {
            for (var id in vm.allItemsMap) {
                if (vm.allItemsMap.hasOwnProperty(id)) {
                    if ($("#" + id).is(":visible")) {
                        vm.allItemsMap[id].checked = vm.selectAll;
                    }
                }
            }
        };
        vm.itemChecked = function () {
            var registrants = _.where(vm.allItemsMap, {
                checked: false
            });
            vm.selectAll = registrants.length < 1;
        };
        vm.selectedRegistrantIds = function () {
            var registrants = _.where(vm.allItemsMap, {
                checked: true
            });
            return _.pluck(_.pluck(registrants, "registrant"), "id");
        };
        vm.noItemsSelected = function () {
            return _.where(vm.allItemsMap.hasOwnProperty("checked"), {
                checked: true
            }).length === 0;
        };
        vm.updateData = function (data) {
            vm.dtInstance.reloadData($q(function (resolve) {
                resolve(data);
            }));
        };
        vm.updateAttendance = function (status) {
            var registrants = vm.selectedRegistrantIds();
            if (registrants.length > 0) {
                if (vm.saving)
                    return;
                var model = {
                    attended: status,
                    activationId: registrants
                };
                vm.saving = true;
                vm.showRegistrantErrors = false;
                learningItemSeminarsResource.updateAttendance({ id: $state.params.id }, model, function () {
                    for (var activation in registrants) {
                        if (registrants.hasOwnProperty(activation)) {
                            var learner = _.find(vm.learnerListModel, { "id": registrants[activation] });
                            learner.attended = status;
                        }
                    }
                    vm.updateData(vm.learnerListModel);
                    vm.saving = false;
                    if (status)
                        messageService.success("seminars.registeredLearners.markAsAttendedSuccessNotify");
                    else
                        messageService.success("seminars.registeredLearners.unmarkAsAttendedSuccessNotify");
                }, function (error) {
                    vm.saving = false;
                    messageService.error(error);
                });
            }
            else {
                vm.saving = false;
                vm.showRegistrantErrors = true;
            }
        };
        vm.removeSelectedLearners = function () {
            var registrants = vm.selectedRegistrantIds();
            if (registrants.length > 0) {
                if (vm.saving)
                    return;
                vm.saving = true;
                vm.showRegistrantErrors = false;
                learningItemSeminarsResource.removeRegistrant({ id: $state.params.id, activationId: registrants }, function () {
                    for (var activation in registrants) {
                        if (registrants.hasOwnProperty(activation)) {
                            vm.learnerListModel = _.without(vm.learnerListModel, {
                                "id": registrants[activation]
                            });
                        }
                    }
                    vm.updateData(vm.learnerListModel);
                    vm.saving = false;
                    messageService.success("seminars.registeredLearners.removedRegistrantSuccessNotify");
                }, function (errorData) {
                    vm.saving = false;
                    messageService.error(errorData);
                });
            }
            else {
                vm.saving = false;
                vm.showRegistrantErrors = true;
            }
        };
        //---Add Registrants--------------
        vm.addRegistrants = function () {
            var modalInstance = $uibModal.open({
                templateUrl: "app/seminar/addRegistrantsView.html",
                controller: "AddRegistrantsCtrl as vm",
                backdrop: "static",
                scope: $scope,
                size: "lg",
                resolve: {
                    data: {
                        code: vm.model.learningItemCode, seminarId: $state.params.id
                    }
                }
            });
            modalInstance.result.then(function () {
                vm.dtInstance.reloadData(true);
            }).catch(angular.noop);
        };
        //---Add Completed Learners ----------
        vm.addCompletedLearners = function () {
            var modalInstance = $uibModal.open({
                templateUrl: "app/seminar/addCompletedLearnersView.html",
                controller: "AddCompletedLearnersCtrl as vm",
                backdrop: "static",
                scope: $scope,
                size: "md",
                resolve: {
                    data: {
                        code: vm.model.learningItemCode, seminarId: $state.params.id
                    }
                }
            });
            modalInstance.result.then(function () {
                vm.dtInstance.reloadData(true);
            }).catch(angular.noop);
        };
        //Print Stuff
        vm.printSignIn = false;
        vm.printClass = false;
        vm.printClassList = function () {
            if (vm.learnerListModel.length > 0) {
                vm.printSignIn = false;
                vm.printClass = true;
                $timeout(function () {
                    window.print();
                }, 500);
            }
            else {
                messageService.warning("seminars.print.noRegistrantsMessage");
            }
        };
        $window.onafterprint = function () {
            vm.printSignIn = false;
            vm.printClass = false;
            console.log("Printing completed...");
        };
        vm.printSignInList = function () {
            if (vm.learnerListModel.length > 0) {
                vm.printClass = false;
                vm.printSignIn = true;
                $timeout(function () {
                    window.print();
                }, 500);
            }
            else {
                messageService.warning("seminars.print.noRegistrantsMessage");
            }
        };
    }
}());
